import { styled } from '@lucidhq/lucidium';
import {
  TextInput,
  TextInputProps,
} from '@lucidhq/lucidium/components/TextInput';
import { RefAttributes } from 'react';

const Container = styled.span`
  display: inline-flex;
  align-items: center;
  width: 150px;
  max-width: 150px;

  input[type='color'] {
    margin-right: 8px;
    -webkit-appearance: none;
    border: none;
    width: auto;
    height: auto;
    cursor: pointer;
    background: none;

    &::-webkit-color-swatch-wrapper {
      padding: 0;
      margin-left: 5px;
      width: 40px;
      height: 40px;
    }

    &::-webkit-color-swatch {
      border: 1px solid #949494;
      border-radius: 6px;
      padding: 0;
    }

    &::-moz-color-swatch {
      padding: 0;
      margin-left: 5px;
      width: 40px;
      height: 40px;
      border: 1px solid #949494;
      border-radius: 6px;
    }
  }
`;

export type ColorPickerProps = TextInputProps &
  RefAttributes<HTMLInputElement> & {
    isDisabled?: boolean;
  };

export const ColorPicker = (props: ColorPickerProps) => {
  const { value, onChange, isDisabled } = props;

  return (
    <Container>
      {/* @ts-ignore */}
      <TextInput
        data-testid="color-picker-input"
        inputLss={{
          width: '90px',
        }}
        {...props}
      />
      <input
        disabled={isDisabled}
        data-testid="color-picker"
        type="color"
        value={value}
        onChange={onChange}
      />
    </Container>
  );
};
